import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesUpdateProductInformationComponent} from "./sales-update-product-information.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [
    SalesUpdateProductInformationComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SalesUpdateProductInformationComponent
  ]
})
export class SalesUpdateProductInformationModule { }
